import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'checkout-abtest-global-settings',
  templateUrl: './abtest-settings.component.html',
  styleUrls: ['./abtest-settings.component.scss'],
  standalone: false,
})
export class AbTestSettingsComponent {
  @Input() formGroup: UntypedFormGroup;

  constructor() {}
}
